import { useCallback, useState } from "react";
import React from 'react';
import { Accordion, Card } from "react-bootstrap";

export default function WmsFaq({ faqData }) {
  const [activeKey, setActiveKey] = useState("0");
  const handleToggle = useCallback(
    (key) => {
      setActiveKey((prevKey) => (prevKey === key ? null : key));
    }, []);

  return (
    <section className="wms-faq ">
      <div className="container wow animate__animated animate__slideInUp" data-wow-delay="0.1s" data-wow-duration="2s">
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-8">
            <div className="heading-center heading-gap">
              <span className="subtitle">Frequently Asked Questions</span>
              <h4 className="heading "> Have a Question?  We’ve Probably Got the Answer </h4>
            </div>
          </div>
          <div className="col-lg-12">
            <Accordion activeKey={activeKey} className="faq-accord">
              {faqData.map(({ id, question, answer, list }) => (
                <Card key={id} className={activeKey === id ? "active" : ""}>
                  <Card.Header>
                    <Accordion.Item eventKey={id}>
                      <Accordion.Header as="h4" onClick={() => handleToggle(id)}>
                        <label>{question}</label>
                        <span>{activeKey === id ? "−" : "+"}</span>
                      </Accordion.Header>
                      <Accordion.Body>
                        {Array.isArray(answer)
                          ? answer.map((p, i) => <p key={i}>{p}</p>)
                          : answer && <p>{answer}</p>}
                        {Array.isArray(list) && list.length > 0 && (
                          <ul className="dots-style">
                            {list.map((li, i) => (  <li key={i}>{li}</li>))}
                          </ul>
                        )}
                      </Accordion.Body>
                    </Accordion.Item>
                  </Card.Header>
                </Card>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}




